import { Button, TextareaAutosize, Typography } from '@mui/material'
import CardTAG from '../../CardTAG'
import DividerTAG from '../../DividerTAG'
import FormLayout from '../../forms/FormLayout'
import timeUtils from '../../../utils/timeUtils'
import { useForm } from 'react-hook-form'
import { FC, useEffect, useState } from 'react'
import { ICaseStatusMessage } from '../../CaseOverview/types'
import reportsService from '../../../services/reportsService'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../store'
import { postCaseStatusMessage } from '../../../store/reports/reportsSlice'
import LabelErrorTAG from '../../LabelErrorTAG'
import { textAreaStyle } from '../../../constants/styleConstants'

interface CaseStatusMessageFormType {
  text: string
}

interface ReportUpdateType {
  selectedReport: any
}

const ReportUpdate: FC<ReportUpdateType> = ({ selectedReport }) => {
  const [caseStatusMessages, setCaseStatusMessages] = useState<ICaseStatusMessage[]>([])
  const dispatch = useDispatch<AppDispatch>()
  const formMethods = useForm<CaseStatusMessageFormType>({
    defaultValues: {
      text: '',
    },
    mode: 'onChange',
  })
  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = formMethods

  // Grab previous message from service and add them to component state
  const getMessages = async () => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    const { data } = await reportsService?.getCaseStatusMessages(selectedReport?.id as number)
    setCaseStatusMessages(data)
  }

  // Fetching messages
  useEffect(() => {
    if (selectedReport) getMessages()
  }, [selectedReport])

  // Reseting form
  const cancelHandler = () => reset()

  // Submitting form
  const saveHandler = (data: CaseStatusMessageFormType) => {
    const { text } = data
    if (data) {
      dispatch(postCaseStatusMessage({ description: text }))
    }
    reset()
    getMessages()
  }

  // Watching changes on text to tweak disabled state of submit btn
  const text = watch('text')

  return (
    <form
      onSubmit={handleSubmit(saveHandler)}
      className='t-case-status-message-form'
      style={{ position: 'relative' }}
    >
      <CardTAG title={'Case Status Message'}>
        <div className='t-field t-vbox'>
          <LabelErrorTAG label={'This message will be visible to the reporting party'} />
          <TextareaAutosize
            {...register('text', {
              required: { value: true, message: 'Message text is required' },
            })}
            style={textAreaStyle}
            minRows={5}
            placeholder='Type Here'
          />
          <span className='t-field-error-msg t-color-red t-font-size-xxs'>
            {errors?.text?.message}
          </span>
        </div>
        <DividerTAG />
        <Typography variant='bodyBold'>Previous Case Status Messages</Typography>
        {caseStatusMessages?.length > 0 &&
          caseStatusMessages.map(message => {
            return (
              <FormLayout key={`${message?.id}`}>
                <Typography variant='labelBold' sx={{ textTransform: 'capitalize' }}>
                  {message?.user_profile?.user?.first_name} {message?.user_profile?.user?.last_name}
                  • {timeUtils.formatTimeWithHours(message?.created_at)}{' '}
                </Typography>
                <Typography variant='bodyRegular'>
                  <div dangerouslySetInnerHTML={{ __html: message?.description }}></div>
                </Typography>
                <DividerTAG />
              </FormLayout>
            )
          })}
      </CardTAG>
      <div className='t-vbox  t-gap-9 t-form-btns'>
        <Button disabled={!text} color='success' variant='contained' type='submit'>
          Submit
        </Button>
        <Button variant='outlined' onClick={cancelHandler}>
          Cancel
        </Button>
      </div>
    </form>
  )
}

export default ReportUpdate
